module.exports = __webpack_public_path__ + "img/messi-no.1f9400d7.svg";